export default __webpack_public_path__ + "static/media/ico_user_cicrle_light.8a12ea70.svg";